import { render, staticRenderFns } from "./ConformacionCopass.Mayor10.vue?vue&type=template&id=f609cc6c&"
import script from "./ConformacionCopass.Mayor10.vue?vue&type=script&lang=js&"
export * from "./ConformacionCopass.Mayor10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports